module.exports = __webpack_public_path__ + "static/img/MS.41d4783c.svg";